import { SR_API_ACTION_HITLIST_TASK_GET_LIST } from 'api/actionTypes';

export function makeHitlistTaskListId({
  highPriority,
  status,
  callOutcome,
  toCompletedAt,
  tourListingId,
}) {
  return [
    'highPriority',
    highPriority,
    'status',
    Array.isArray(status) ? status.join('_') : status,
    'callOutcome',
    callOutcome,
    'toCompletedAt',
    toCompletedAt,
    'tourListingId',
    tourListingId,
  ].join(':');
}

export default async function getList(
  { state, apiClient },
  { highPriority, status, callOutcome, toCompletedAt, tourListingId, refresh },
) {
  const hitlistTaskListId = makeHitlistTaskListId({
    highPriority,
    status,
    callOutcome,
    toCompletedAt,
    tourListingId,
  });

  const statePath = ['hitlistTask', 'list', hitlistTaskListId];
  if (state.get(statePath) && !refresh) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_HITLIST_TASK_GET_LIST,
    state: state,
    queryId: hitlistTaskListId,
    payload: {
      highPriority,
      status,
      callOutcome,
      toCompletedAt,
      tourListingId,
    },
    onSuccess(hitlistTasks) {
      state.set(statePath, hitlistTasks);
    },
  });
}
